"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDomainCountryToMangopayCountry = transformDomainCountryToMangopayCountry;
function transformDomainCountryToMangopayCountry(countryISOCode) {
    return countryISOCode ? countryISOCode.toUpperCase() : undefined;
}
//# sourceMappingURL=transformDomainCountryToMangopayCountry.js.map